/**
 * The allow-list of tokens a theme may set.
 *
 * A theme document arrives from the database and is compiled straight into CSS
 * text, so the set of names it can write has to be closed. Both halves of the
 * list are GENERATED from the stylesheets they describe - the ramps by
 * scripts/generate-color-tokens.cjs, the rest by
 * scripts/generate-token-registry.cjs - so the contract cannot drift from the
 * CSS. tokenRegistry.test.ts re-parses the stylesheets and fails if it has.
 */
import rampDefaults from './rampDefaults.json';
import tokenNames from './tokenNames.json';

const RAMP_NAMES = Object.keys(rampDefaults as Record<string, string>).map((k) => `c-${k}`);
const { semantic, component, geometry } = tokenNames as {
  semantic: string[];
  component: string[];
  geometry: string[];
};

export const TOKEN_NAMES: readonly string[] = Object.freeze([
  ...RAMP_NAMES,
  ...semantic,
  ...component,
  ...geometry,
]);

const TOKEN_SET = new Set(TOKEN_NAMES);

/** True when `name` (no leading `--`) is a token a theme is allowed to set. */
export function isValidToken(name: string): boolean {
  return TOKEN_SET.has(name);
}

export const TOKEN_GROUPS = Object.freeze({
  ramp: Object.freeze(RAMP_NAMES),
  semantic: Object.freeze(semantic),
  component: Object.freeze(component),
  geometry: Object.freeze(geometry),
});
